import { useQuery } from '@tanstack/react-query'
import { useParams, Link } from 'react-router-dom'
import { examsApi } from '../../api/exams'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Loading from '../../components/common/Loading'
import Card from '../../components/common/Card'
import './Exams.css'

const Exams = () => {
  const { courseId } = useParams()

  const { data, isLoading } = useQuery({
    queryKey: ['exams', courseId],
    queryFn: () => examsApi.getExams({ course_id: courseId }),
  })

  if (isLoading) {
    return (
      <>
        <Header />
        <Loading fullScreen text="جاري التحميل..." />
        <Footer />
      </>
    )
  }

  const exams = data?.data?.exams || []

  return (
    <div className="exams-page bg-gray-900 min-h-screen">
      <Header />
      <main className="exams-main bg-gray-900">
        <div className="container mx-auto px-4">
          <h1 className="page-title text-white">الامتحانات</h1>
          <div className="exams-list">
            {exams.map((exam) => (
              <Card key={exam.id} className="exam-card">
                <div className="exam-header">
                  <h3 className="exam-title">{exam.title}</h3>
                  <span className={`exam-status ${exam.is_active ? 'active' : 'inactive'}`}>
                    {exam.is_active ? 'نشط' : 'غير نشط'}
                  </span>
                </div>
                <p className="exam-description">{exam.description}</p>
                <div className="exam-meta">
                  <span>المدة: {exam.duration_minutes} دقيقة</span>
                  <span>الدرجة المطلوبة: {exam.passing_score}%</span>
                </div>
                {exam.has_attempted && (
                  <div className="exam-result">
                    <span>أفضل درجة: {exam.best_score}%</span>
                  </div>
                )}
                {exam.has_attempted && exam.best_score && (
                  <Link to={`/exams/${exam.id}/result`} className="exam-result-link">
                    عرض النتيجة
                  </Link>
                )}
                <Link to={`/exams/${exam.id}/take`} className="exam-button">
                  {exam.has_attempted ? 'إعادة المحاولة' : 'بدء الامتحان'}
                </Link>
              </Card>
            ))}
            {exams.length === 0 && (
              <div className="empty-state">
                <p>لا توجد امتحانات متاحة</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Exams

